module.exports = __webpack_public_path__ + "img/pic_head_nor.2ac3844f.png";